(() => {
  function attachStickyColumn(host, purchaseRoot) {
    const heading = purchaseRoot.querySelector('h1');
    if (!heading || host.contains(heading)) return;
    let column = host;
    while (column.parentElement && column.parentElement !== purchaseRoot && !column.parentElement.contains(heading)) {
      column = column.parentElement;
    }
    if (column.parentElement && column.parentElement.contains(heading)) {
      column.classList.add('ir-pdp-gallery-sticky-v5');
    }
  }
  function init(scope = document) {
    const template = document.getElementById('IrPdpGalleryV5');
    if (!template) return;
    scope.querySelectorAll('[data-market-variant][id^="ir-pro-"]').forEach(root => {
      const hosts = new Set(root.querySelectorAll('[data-ir-carousel="true"]'));
      root.querySelectorAll('picture[style*="--ir-attributes-currentitem:"]').forEach(picture => {
        const parent = picture.parentElement;
        if (parent.querySelectorAll(':scope > picture').length > 1) hosts.add(parent);
      });
      hosts.forEach(host => {
        if (host.dataset.irPdpV5 === 'true') return;
        host.dataset.irPdpV5 = 'true';
        host.classList.add('ir-pdp-gallery-host-v5');
        host.replaceChildren(template.content.cloneNode(true));
        if (!host.matches('[data-ir-carousel]')) attachStickyColumn(host, root);
        else host.parentElement.classList.add('ir-pdp-gallery-mobile-start-v5');
      });
    });
    scope.querySelectorAll('[data-ir-gallery-v3]').forEach(root => {
      if (root.dataset.irPdpV5 === 'true') return;
      root.dataset.irPdpV5 = 'true';
      root.classList.add('ir-pdp-gallery-host-v5');
      root.replaceChildren(template.content.cloneNode(true));
      const purchaseRoot = root.closest('#ir-hair-growth');
      if (purchaseRoot) attachStickyColumn(root, purchaseRoot);
      root.closest('#product')?.classList.add('ir-pdp-gallery-mobile-start-v5');
    });
    scope.querySelectorAll('[id*="__ir_stand_purchase"]').forEach(root => {
      const hosts = new Set(root.querySelectorAll('[data-ir-carousel="true"]'));
      root.querySelectorAll('picture[style*="--ir-attributes-currentitem:"]').forEach(picture => {
        const parent = picture.parentElement;
        if (parent.querySelectorAll(':scope > picture').length > 1) hosts.add(parent);
      });
      hosts.forEach(host => {
        if (host.dataset.irPdpV5 === 'true') return;
        host.dataset.irPdpV5 = 'true';
        host.classList.add('ir-pdp-gallery-host-v5');
        host.replaceChildren(template.content.cloneNode(true));
        if (!host.matches('[data-ir-carousel]')) attachStickyColumn(host, root);
        else host.parentElement.classList.add('ir-pdp-gallery-mobile-start-v5');
      });
    });
    scope.querySelectorAll('[data-ir-slim-lite-section]').forEach(root => {
      const hosts = new Set(root.querySelectorAll('[data-ir-carousel="true"]'));
      root.querySelectorAll('picture[style*="--ir-attributes-product-images-0"]').forEach(picture => {
        if (!picture.closest('[data-ir-carousel]')) hosts.add(picture.parentElement.parentElement);
      });
      hosts.forEach(host => {
        if (host.dataset.irPdpV5 === 'true') return;
        host.dataset.irPdpV5 = 'true';
        host.classList.add('ir-pdp-gallery-host-v5');
        host.replaceChildren(template.content.cloneNode(true));
        if (!host.matches('[data-ir-carousel]')) attachStickyColumn(host, root);
        else host.parentElement.classList.add('ir-pdp-gallery-mobile-start-v5');
      });
    });
    scope.querySelectorAll('[data-ir-calming-lamp]').forEach(root => {
      const hosts = new Set(root.querySelectorAll('[data-ir-carousel="true"]'));
      root.querySelectorAll('picture[style*="--ir-attributes-currentitem:"]').forEach(picture => {
        const parent = picture.parentElement;
        if (parent.querySelectorAll(':scope > picture').length > 1) hosts.add(parent);
      });
      hosts.forEach(host => {
        if (host.dataset.irPdpV5 === 'true') return;
        host.dataset.irPdpV5 = 'true';
        host.classList.add('ir-pdp-gallery-host-v5');
        host.replaceChildren(template.content.cloneNode(true));
        if (!host.matches('[data-ir-carousel]')) attachStickyColumn(host, root);
        else host.parentElement.classList.add('ir-pdp-gallery-mobile-start-v5');
      });
    });
    scope.querySelectorAll('[id*="__ir_face_mask_purchase"]').forEach(root => {
      const hosts = new Set(root.querySelectorAll('[data-ir-carousel="true"]'));
      root.querySelectorAll('picture[style*="--ir-attributes-product-images-"]').forEach(picture => {
        if (picture.closest('[data-ir-carousel]')) return;
        hosts.add(picture.parentElement.parentElement);
      });
      hosts.forEach(host => {
        if (host.dataset.irPdpV5 === 'true') return;
        host.dataset.irPdpV5 = 'true';
        host.classList.add('ir-pdp-gallery-host-v5');
        host.replaceChildren(template.content.cloneNode(true));
        if (!host.matches('[data-ir-carousel]')) attachStickyColumn(host, root);
        else host.parentElement.classList.add('ir-pdp-gallery-mobile-start-v5');
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
